import { Divider } from '@tribeplatform/react-ui-kit/Divider'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { T } from '../../i18n/index.js'

export const RecurringEventUpdateConfirm = () => {
  return (
    <div className="flex flex-col gap-2">
      <Text>
        <T
          id="EventForm.RecurringEvent.Update.Confirmation.Description1"
          defaultMessage="This event repeats on a schedule. Changing it's date or time will recreate all events in the series."
        />
      </Text>
      <Divider />
      <Text className="font-medium">
        <T
          id="EventForm.RecurringEvent.Update.Confirmation.WhatWillHappen"
          defaultMessage="What happens next?"
        />
      </Text>
      <ul className="list-disc list-inside">
        <li>
          <T
            id="EventForm.RecurringEvent.Update.Confirmation.WhatWillHappen.1"
            defaultMessage="The current RSVPs will be cancelled."
          />
        </li>
        <li>
          <T
            id="EventForm.RecurringEvent.Update.Confirmation.WhatWillHappen.2"
            defaultMessage="Attendees will need to RSVP again for the new event."
          />
        </li>
        <li>
          <T
            id="EventForm.RecurringEvent.Update.Confirmation.WhatWillHappen.3"
            defaultMessage="Any event-specific data will be cleared."
          />
        </li>
      </ul>
      <Divider />
      <Text className="font-medium">
        <T
          id="EventForm.RecurringEvent.Update.Confirmation.Description2"
          defaultMessage="Are you sure you want to continue?"
        />
      </Text>
    </div>
  )
}
